import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { SYSTEM_PATH, USER_TYPE } from '../../../core/configs/constants';
import { useStore } from '../../../core/utils/hook';
import { canShowShareKnowledgeMenu, canShowTrainingListMenu } from '../../../core/utils/gaMenuPermissions';

const ProfileSideBar = observer(({ type }) => {

    // other
    const location = useLocation();

    // store
    const { userStore: { getProfile, updateProfile, profile, userInfoHeader }, authStore: { userInfo, token } } = useStore();


    const params = useParams() || {};
    const path = params['*'];


    if (!(profile || userInfo)?.id) return null;

    return (
        <div className="aside-left">
            <p className="title-admin">
                <img
                    src='/images/icon9.svg'
                    alt=""
                />
                <span>{`${(profile || userInfoHeader)?.firstName || ''} ${(profile || userInfoHeader)?.lastName || ''}様`}</span>
            </p>
            <ul className="list-account">
                <li className={classNames('li-1',
                    (location.pathname === SYSTEM_PATH.PROFILE || location.pathname === SYSTEM_PATH.PROFILE_EDIT) && 'active')}>
                    <Link to={SYSTEM_PATH.PROFILE}>ユーザー情報</Link>
                </li>
                <li className="li-2">
                    <Link to={SYSTEM_PATH.CHANGE_PASSWORD}>パスワード変更</Link>
                </li>
                {
                    (userInfo?.roleId === USER_TYPE.STUDENT_INDIVIDUAL || userInfo?.roleId === USER_TYPE.STUDENT_GROUP) &&
                    <>
                        <li className={classNames('li-3', location.pathname === SYSTEM_PATH.PURCHASE_HISTORY && 'active')}>
                            <Link to={SYSTEM_PATH.PURCHASE_HISTORY}>購入履歴</Link>
                            {
                                userInfoHeader?.haveTransactionNoPaymentAndProcessing &&
                                <span className='dot-highlight'></span>
                            }
                        </li>
                        <li className={classNames('li-4', location.pathname === SYSTEM_PATH.TOOL_CERTIFICATE && 'active')}>
                            <Link to={SYSTEM_PATH.TOOL_CERTIFICATE} className='d-flex align-items-center flex-gap-5'>
                                単位管理ツール
                                {
                                    token && !userInfoHeader?.isSettingToolcertificate && (
                                        <img src="/images/warning_icon.svg" alt="" />
                                    )
                                }
                            </Link>
                        </li>
                    </>
                }
                {
                    userInfo?.roleId === USER_TYPE.GROUP_MANAGER &&
                    <>
                        {
                            canShowTrainingListMenu(userInfoHeader) && (
                                <li className={classNames('li-5', (
                                    location.pathname === SYSTEM_PATH.COMPANY_TRAINING_LIST ||
                                    location.pathname.startsWith('/company-training-ticket-plan') ||
                                    location.pathname.startsWith('/company-training-course')
                                ) && 'active')}>
                                    <Link to={SYSTEM_PATH.COMPANY_TRAINING_LIST}>研修一覧</Link>
                                </li>
                            )
                        }
                        {
                            canShowShareKnowledgeMenu(userInfoHeader) && (
                                <>
                                    <li className={classNames('li-7',
                                        (location.pathname === SYSTEM_PATH.SHARE_KNOWLEDGE) && 'active')}>
                                        <Link to={SYSTEM_PATH.SHARE_KNOWLEDGE}>シェアナレッジ</Link>
                                    </li>
                                    <li className={classNames('li-6', location.pathname === SYSTEM_PATH.SHARE_KNOWLEDGE_REQUEST_LIST && 'active')}>
                                        <Link to={SYSTEM_PATH.SHARE_KNOWLEDGE_REQUEST_LIST}>利用履歴</Link>
                                    </li>
                                </>
                            )
                        }
                    </>
                }
                <li className={classNames('li-8', location.pathname === SYSTEM_PATH.ACCOUNT_SETTING && 'active')}>
                    <Link to={SYSTEM_PATH.ACCOUNT_SETTING}>メールニュース受信設定</Link>
                </li>
            </ul>
        </div>
    )
})

export default ProfileSideBar;